<script setup lang="ts">
import { t } from '@/utils/i18n';

definePage({
  meta: {
    allowAnonymous: true,
  },
});
</script>

<template>
  <div class="mt-5">
    <div class="flex justify-center">
      <BotList class="max-w-xl" />
    </div>
    <USeparator class="my-5" />
    <AppIcon class="my-5 sm:w-80 sm:h-80 w-64 h-64" />

    <h1 class="font-bold text-2xl sm:text-4xl mb-4 transition-all">
      {{ t('Welcome to the') }} <AppText class="text-2xl! sm:text-4xl!" />
    </h1>
    <div>{{ t('This page allows you to control your trading bot.') }}</div>
    <USeparator class="my-5" />
    <p class="mb-2">
      {{ t('If you need any help, please refer to the') }}
      <a
        class="text-primary underline cursor-pointer"
        href="https://www.freqtrade.io/en/latest/"
        target="_blank"
      >
        {{ t('Freqtrade Documentation') }}
      </a>
      .
    </p>

    <p class="mb-5">
      {{ t('Have fun -') }} <i>{{ t('wishes you the Freqtrade team') }}</i>
    </p>
  </div>
</template>
